import React from "react";
import { XMarkIcon, FolderIcon } from "@heroicons/react/24/outline";
import { Folder } from "../types";

interface FolderActionModalProps {
  show: boolean;
  onClose: () => void;
  editingFolder: Folder | null;
  folderName: string;
  setFolderName: (name: string) => void;
  folderDescription: string;
  setFolderDescription: (desc: string) => void;
  folderSortOrder: number;
  setFolderSortOrder: (order: number) => void;
  handleSubmit: (e: React.FormEvent) => void;
}

const FolderActionModal: React.FC<FolderActionModalProps> = ({
  show,
  onClose,
  editingFolder,
  folderName,
  setFolderName,
  folderDescription,
  setFolderDescription,
  folderSortOrder,
  setFolderSortOrder,
  handleSubmit,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 overflow-y-auto z-50">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
          onClick={onClose}
        ></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4 flex items-center justify-between">
            <h3 className="text-xl font-bold text-white flex items-center">
              <FolderIcon className="h-6 w-6 mr-2" />
              {editingFolder ? "ແກ້ໄຂໂຟລເດີ" : "ສ້າງໂຟລເດີໃໝ່"}
            </h3>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-200 transition-colors"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="px-6 py-6 space-y-5">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                ຊື່ໂຟລເດີ *
              </label>
              <input
                type="text"
                required
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                placeholder="ປ້ອນຊື່ໂຟລເດີ"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                ຄຳອະທິບາຍ
              </label>
              <textarea
                value={folderDescription}
                onChange={(e) => setFolderDescription(e.target.value)}
                rows={3}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                placeholder="ປ້ອນຄຳອະທິບາຍໂຟລເດີ"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                ລຽງລຳດັບ
              </label>
              <input
                type="number"
                value={folderSortOrder}
                onChange={(e) =>
                  setFolderSortOrder(parseInt(e.target.value) || 0)
                }
                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
                placeholder="ລຳດັບການສະແດງຜົນ"
              />
            </div>

            <div className="flex justify-end space-x-3 pt-2">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2.5 border border-gray-300 rounded-xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200 shadow-sm"
              >
                ຍົກເລີກ
              </button>
              <button
                type="submit"
                className="px-8 py-2.5 rounded-xl text-sm font-bold text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-lg hover:shadow-xl active:scale-95 transition-all duration-200"
              >
                {editingFolder ? "ບັນທຶກ" : "ສ້າງໂຟລເດີ"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FolderActionModal;
